module.exports = __webpack_public_path__ + "static/media/M26-Pershing.c6860fef.png";